<app-dropdown [anchor]="anchor" [theme]="theme" [width]="width" position="center" dpwChild [dpwChildEnabled]="childOverlay" #dropdown>
  <app-dropdown-select
    class="app-dropdown-select"
    [multi]="multi"
    [title]="title"
    (search)="search($event)"
    #dropdownSelect>
    @for (item of internalItems(); track $index) {
      <button
        style="white-space: unset; text-align: initial"
        [appButton]="$any(item).icon?.name ? item.icon : undefined"
        [isoCode]="item.isoCode"
        [disabled]="item.disabled"
        class="solid select {{ selectClass }} flex-justify-start"
        [ngClass]="{ transparent: item !== controlDirective?.value }"
        [dpwSelectValue]="item"
        #itemDirective="dpwSelectValue">
        @if (multi) {
          <app-ui-check-box [value]="itemDirective.isSelected$ | async" style="pointer-events: none"></app-ui-check-box>
        }
        @if($any(item).icon && !$any(item).icon.name) {
          <img class="img-icon" src="{{item.icon}}" />
        }
        <span class="value">
          {{ item.name }}
        </span>
        <app-icon [icon]="checkIcon"></app-icon>
      </button>
    }
  </app-dropdown-select>
</app-dropdown>

@let value = showSelected?.value || (_dropdown?.changed | async);
<div
  class="inp"
  [ngClass]="{ empty: !value || (isArray(value) && !value.length) }"
  [attr.contenteditable]="false"
  [attr.name]="name"
  [attr.ph]="placeholder"
  #input>
  @if (isArray(value)) {
    <div class="badges">
      @for (v of value; track $index) {
        <app-badge class="badge hg color-inherit">
          @if (v?.icon) {
            <app-icon [icon]="v?.icon" class="margin-right-tn"></app-icon>
          }
          {{ v }}
          <app-icon
            [icon]="closeIcon"
            (mousedown)="$event.stopImmediatePropagation(); $event.preventDefault()"
            (click)="dropdownSelect.onItemSelected(v)"></app-icon>
        </app-badge>
      }
    </div>
  } @else {
    @if ($any(value)?.icon) {
      @if($any(value)?.icon.name) {
        <app-icon [icon]="$any(value)?.icon" class="margin-right-tn"></app-icon>
      } @else {
        <img class="img-icon" src="{{$any(value)?.icon}}"/>
      }
    }
    @if ($any(value)?.isoCode) {
      <app-flag [code]="$any(value)?.isoCode" class="margin-right-tn {{$any(value)?.isoCode}}"></app-flag>
    }
    @if (showSelected?.icon) {
      <app-icon [icon]="showSelected?.icon" class="margin-right-tn"></app-icon>
    }
    <span class="extracted-value">{{ valueExtractor ? valueExtractor($any(value)) : value }}</span>
  }
</div>
<app-input-extras class="extras" [extras]="['dropdown']"></app-input-extras>
